import { useCardLinkedOffersEnrollmentStatus } from "byzantine/src/dbbl/businessLogic/entities/cardLinkedOffers/hooks";
import useCardLinkedOffersFeature from "../../CardLinkedOffers/hooks";
import CardOffersUnenrolled from "./CardOffersUnenrolled";
import CardOffersEnrolled from "./CardOffersEnrolled";

interface CardOffersProps {
  maxOffers?: number;
}

const CardOffers = ({ maxOffers }: CardOffersProps) => {
  const isCardLinkedOffersEnabled = useCardLinkedOffersFeature();
  const isEnrolled = useCardLinkedOffersEnrollmentStatus();

  // Don't render if feature flag is disabled
  if (!isCardLinkedOffersEnabled) {
    return null;
  }

  // Check enrollment status to determine which component to render
  if (isEnrolled) {
    return <CardOffersEnrolled maxOffers={maxOffers} />;
  }

  return <CardOffersUnenrolled />;
};

export default CardOffers;
